<script>
import { eventListMethod } from '@state/helpers'
export default {
  props: {
    data: {
      type: Object,
      required: true,
      default: () => {},
    },
    size: {
      type: String,
      default: 'sm',
    },
  },
  data() {
    return {
      show: true,
    }
  },
  methods: {
    ...eventListMethod,
    approveEvent(data) {
      const eventData = {
        id: data._id,
        status: 'true',
      }
      this.updateEvent({ eventData }).then((data) => {
        this.isLoading = false
        this.$router.push({ name: 'event.list' })
      })
    },
    rejectEvent(data) {
      const eventData = {
        id: data._id,
        status: 'false',
      }
      this.updateEvent({ eventData }).then((data) => {
        this.isLoading = false
        this.$router.push({ name: 'event.list' })
      })
    },
  },
}
</script>
<template>
  <div class="alert">
    <b-modal id="add-modal" v-model="show" :hide-footer="true">
      <template v-slot:modal-title>
        <h4>Add Event</h4> </template
      ><br />
      <b-button class="btn btn-info mb-2" @click="approveEvent(data)"
        >Accept</b-button
      >&nbsp;
      <b-button class="btn btn-info mb-2" @click="rejectEvent(data)"
        >Reject</b-button
      >
    </b-modal>
  </div>
</template>
